module.exports = __webpack_public_path__ + "static/rtx-3090-8155b65e728b8b4bea7e17609b0e5ce8.png";